import {
  PayloadAction,
  createDraftSafeSelector,
  createSlice,
} from '@reduxjs/toolkit'

import { NameSpace } from '../types'
import { RootState } from '../index'

export interface SpotifyCampaignMatchingProcessState {
  totalPrice: number | null
}

const initialState: SpotifyCampaignMatchingProcessState = {
  totalPrice: null,
}

export const spotifyCampaignMatchingProcess = createSlice({
  initialState,
  name: NameSpace.SPOTIFY_CAMPAIGN_MATCHING,
  reducers: {
    setCampaignBudget(state, action: PayloadAction<number>) {
      state.totalPrice = action.payload
    },
  },
})

const getState = (state: RootState): SpotifyCampaignMatchingProcessState =>
  state.spotifyCampaignMatchingProcess

export const spotifyTotalPriceSelector = createDraftSafeSelector(
  getState,
  ({ totalPrice }) => totalPrice,
)

export const getIsEnoughBalanceSelector = createDraftSafeSelector(
  (state: RootState) => ({
    balance: Number(state.authentication.user.user.balance),
    price: Number(state.spotifyCampaignMatchingProcess.totalPrice),
  }),
  ({ balance, price }) => balance >= price && Boolean(price),
)

export const { setCampaignBudget } = spotifyCampaignMatchingProcess.actions
